import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import InputGroup from '../../form/input-group';
import loadable from '@loadable/component';

const DropIn = loadable(() => import('braintree-web-drop-in-react'));

class Component extends BaseComponent {
    constructor() {
        super();

        this.state = {
            bt_instance: null,
            password: null,
            error: null,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.bt_instance != this.state.bt_instance) {
            return true;
        }

        if (nextState.error != this.state.error) {
            return true;
        }

        if (nextState.password != this.state.password) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (
            nextProps.checkout.type != this.props.checkout.type
            &&
            (nextProps.checkout.type == 'drts' || this.props.checkout.type == 'drts')
        ) {
            return true;
        }

        return false;
    }

    render({ braintree, checkout, submitting, user, mode }, { bt_instance, password }) {
        if (checkout && checkout.order && !checkout.order.finalized) {
            if (
                mode != 'drt'
                ||
                this.props.checkout.type == 'drts'
                ||
                this.props.user.kcs.total < this.props.product.price.kc.current
            ) {
                return (
                    <creditcard mode={mode}>
                        <row className='is-justified-center has-margin-20-top'>
                            <column className='is-8 is-12-mobile'>
                                <DropIn
                                    options={{
                                        authorization: braintree.client_token,
                                        environment: braintree.environment,
                                        vaultManager: true,
                                        card: {
                                            cardholderName: {
                                                required: true,
                                            },
                                            overrides: {
                                                fields: {
                                                    number: {
                                                        placeholder: '1234 5678 9012 3456',
                                                    },
                                                    cvv: {
                                                        placeholder: '123',
                                                    },
                                                },
                                            },
                                        },
                                    }}
                                    onInstance={instance => this.setState({ bt_instance: instance })}
                                />
                            </column>
                        </row>
                        <row className='is-justified-center'>
                            <column className='is-8 is-12-mobile has-padding-15-top'>
                                <p className='has-text-size-14'>
                                    For additional security, please confirm your password to use your credit card on
                                    file. If you would like to enter a new credit card, use the "Choose another way
                                    to pay" link above.
                                </p>
                            </column>
                        </row>
                        <row className='is-justified-center'>
                            <column className='is-4 has-text-right has-padding-5-right'>
                                <span className='has-line-height-36 has-text-uppercase'>User ID:</span>
                            </column>
                            <column className='is-4 is-7-mobile has-padding-5-left has-padding-10-bottom'>
                                <span className='has-text-size-14 has-line-height-36'>{user.email}</span>
                            </column>
                        </row>
                        <row className='is-justified-center'>
                            <column className='is-3 has-text-right has-padding-5-right has-padding-10-top'>
                                <label
                                    className='has-line-height-36 has-text-uppercase'
                                    htmlFor='js-saved-credit-card-input'
                                >
                                    Password:
                                </label>
                            </column>
                            <column className='is-3 is-7-mobile has-padding-5-left has-padding-10-bottom'>
                                <InputGroup
                                    name='password'
                                    type='password'
                                    onInput={(e) => this.setState({ password: e.target.value })}
                                />
                            </column>
                        </row>
                        <row>
                            <column className='is-12 has-text-center has-padding-15'>
                                <button
                                    disabled={!bt_instance || !password || submitting}
                                    className={`button ${!bt_instance || !password || submitting ? 'disabled' : ''}`}
                                    onClick={this.submitCheckout}
                                >
                                    {submitting ? 'submitting…' : checkout.button_text}
                                </button>
                            </column>
                        </row>
                    </creditcard>
                );
            }
        }

        return (<creditcard mode={mode} />);
    }

    submitCheckout = (e) => {
        e.preventDefault();

        this.props.checkoutUpdate({ error: null });

        this.state.bt_instance.requestPaymentMethod().then((payload) => {
            this.props.checkoutSubmit({
                bt: payload,
                order: this.props.checkout.order,
                type: this.props.checkout.type,
                package: this.props.checkout.package,
                total: this.props.checkout.total,
                password: this.state.password,
            });
        }).catch((err) => {
            this.props.checkoutUpdate({
                error: err && err.message
                    ? err.message
                    : 'An error has occurred. Please contact <a href="service">customer support.</a>',
            });
        });
    }
}

const mapStateToProps = (state) => ({
    braintree: state.braintree,
    checkout: state.checkout,
    submitting: state.checkout && state.checkout.submitting,
    user: state.user,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutSubmit: (payload) => dispatch({ type: 'checkout:credit-card', payload: payload }),
    checkoutUpdate: (payload) => dispatch({ type: 'checkout:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);